
/* ---------------- State ---------------- */
function SGID(id){var r=document.querySelector("#sav-root");if(r){var el=r.querySelector('[id="'+id+'"]');if(el)return el;}return document.querySelector('[id="'+id+'"]');}
const S = {
  step:0, order:null, noOrder:false, motif:null,
  selProducts:[], famille:null, answers:{}, files:[], solution:null,
  contact:{nom:'',email:'',tel:''}
};

const MOTIFS = {
  defaut:   {ico:'⚡', t:'Produit défectueux', d:"Ne s'allume pas / clignote / en panne"},
  casse:    {ico:'📦', t:'Endommagé à la livraison', d:'Cassé ou abîmé à la réception'},
  erreur:   {ico:'🔀', t:'Erreur de produit', d:'Article différent de ma commande'},
  manquant: {ico:'🧩', t:'Pièce / accessoire manquant', d:'Il manque un élément dans le colis'},
  retract:  {ico:'↩️', t:"Changement d'avis", d:'Rétractation sous 14 jours'},
  garantie: {ico:'🛡️', t:'Question / garantie', d:'Une question, un conseil, la garantie'}
};

/* -------- Familles produit + diagnostic ciblé -------- */
const FAMILLES = {
  ruban: { ico:'🎗️', label:'Ruban LED', kw:['ruban','strip','bandeau','flexible'],
    q:[
      {id:'type',l:'Type de ruban',type:'select',opts:["Monochrome (une seule couleur)","Blanc variable (CCT)","RGB","RGBW / RGBWW","Adressable (digital / IC)"],req:true},
      {id:'tension',l:'Tension du ruban',type:'select',opts:["12V","24V","220V (haute tension)","Je ne sais pas"],req:true},
      {id:'longueur',l:'Longueur totale installée',type:'text',ph:'ex : 8 m',req:true},
      {id:'coupe',l:'Ruban coupé ou rallongé ?',type:'select',opts:["Non, tel quel","Coupé aux marques prévues","Rallongé (connecteur / soudure)"],req:false},
      {id:'alim',l:"Puissance du transfo qui l'alimente",type:'text',ph:'ex : 60W',req:false},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas du tout","Une portion reste éteinte","Baisse d'intensité en bout de ruban","Scintille / clignote","Mauvaises couleurs (RGB)","Chauffe anormalement"],req:true},
      {id:'enroule',l:'Est-il resté enroulé sur sa bobine allumé ?',type:'select',opts:["Non, bien déroulé","Oui, encore enroulé"],req:false}
    ]},
  transfo: { ico:'🔌', label:'Transformateur / Driver / Alimentation', kw:['transfo','transformateur','driver','alimentation'],
    q:[
      {id:'tension',l:'Tension de sortie',type:'select',opts:["12V","24V","Autre / je ne sais pas"],req:true},
      {id:'puissance',l:'Puissance du transfo',type:'text',ph:'ex : 100W',req:true},
      {id:'ptype',l:'Type de transfo',type:'select',opts:["Tension constante (V)","Courant constant (mA)","Dimmable / variable","Non dimmable","Je ne sais pas"],req:false},
      {id:'charge',l:'Que branche-t-il ? (produits + puissance totale)',type:'text',ph:'ex : ruban 8m ~48W',req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Aucune sortie (rien ne s'allume)","Sortie faible / tension basse","Chauffe excessivement","Claquements / grésillement","Coupe par intermittence","Fait disjoncter le circuit"],req:true},
      {id:'avide',l:'Testé à vide (débranché de la charge) ?',type:'select',opts:["Oui, testé à vide","Non, pas encore testé"],req:false},
      {id:'variateur',l:'Branché sur variateur / minuterie / détecteur ?',type:'select',opts:["Non, alimentation directe","Sur variateur / dimmer","Sur minuterie / détecteur"],req:false}
    ]},
  ampoule: { ico:'💡', label:'Ampoule LED', kw:['ampoule','bulb','e27','e14','gu10','g9','gu5.3','filament'],
    q:[
      {id:'culot',l:'Type de culot',type:'select',opts:["E27","E14","GU10","G9","GU5.3 / MR16","B22","Autre"],req:true},
      {id:'variateur',l:'Installée sur un variateur (dimmer) ?',type:'select',opts:["Non","Oui","Je ne sais pas"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas","Scintille / papillote","Reste faiblement allumée éteinte (effet fantôme)","Grésille","Luminosité faible","Durée de vie très courte"],req:true},
      {id:'ferme',l:'Dans un luminaire fermé / encastré ?',type:'select',opts:["Non, ouvert / aéré","Oui, fermé / encastré"],req:false},
      {id:'inter',l:'Interrupteur avec voyant lumineux ?',type:'select',opts:["Non","Oui"],req:false}
    ]},
  spot: { ico:'🔦', label:'Spot / Encastrable', kw:['spot','encastr','downlight'],
    q:[
      {id:'tension',l:'Alimentation',type:'select',opts:["Driver 12V","Driver 24V","230V direct","Je ne sais pas"],req:true},
      {id:'nb',l:'Combien de spots sur le même transfo ?',type:'text',ph:'ex : 6',req:false},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas","Un spot sur plusieurs est en panne","Scintille","Chauffe anormalement","Clignote"],req:true},
      {id:'driver',l:"Driver d'origine ou remplacé ?",type:'select',opts:["Driver d'origine fourni","Driver remplacé / autre","Je ne sais pas"],req:false}
    ]},
  plafonnier: { ico:'⬜', label:'Plafonnier / Dalle / Panneau', kw:['plafonnier','dalle','panneau','panel','hublot'],
    q:[
      {id:'driver',l:'Alimentation',type:'select',opts:["Driver externe fourni","Alimentation intégrée","Je ne sais pas"],req:false},
      {id:'commande',l:'Piloté comment ?',type:'select',opts:["Interrupteur simple","Télécommande","Détecteur de mouvement","Application / connecté"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas","Scintille / papillote","Zones sombres / taches","Bourdonnement","Clignote","Ne répond plus à la télécommande"],req:true}
    ]},
  projecteur: { ico:'🏗️', label:'Projecteur / Extérieur', kw:['projecteur','floodlight','exterieur','extérieur'],
    q:[
      {id:'usage',l:'Usage',type:'select',opts:["Intérieur","Extérieur"],req:true},
      {id:'detecteur',l:'Avec détecteur de mouvement ?',type:'select',opts:["Non","Oui"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas","Clignote","S'éteint après quelques secondes","Le détecteur ne réagit pas","Buée / infiltration d'eau","Chauffe anormalement"],req:true}
    ]},
  telecommande: { ico:'🎛️', label:'Télécommande / Contrôleur RGB', kw:['télécommande','telecommande','contrôleur','controleur','récepteur','recepteur','remote'],
    q:[
      {id:'techno',l:'Technologie',type:'select',opts:["RF (radio)","IR (infrarouge)","WiFi","Bluetooth","Je ne sais pas"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne répond pas du tout","Portée / distance faible","Couleurs incorrectes","Perte de synchronisation","N'appaire plus au récepteur"],req:true},
      {id:'pile',l:'Pile changée / testée ?',type:'select',opts:["Oui","Non"],req:false},
      {id:'zones',l:'Combien de récepteurs / zones ?',type:'text',ph:'ex : 3',req:false},
      {id:'distance',l:'Distance télécommande ↔ récepteur',type:'text',ph:'ex : 4 m avec un mur',req:false}
    ]},
  reglette: { ico:'📏', label:'Réglette / Tube LED', kw:['réglette','reglette','tube','néon','neon'],
    q:[
      {id:'longueur',l:'Longueur',type:'text',ph:'ex : 120 cm',req:false},
      {id:'serie',l:'Raccordées en série (plusieurs à la suite) ?',type:'select',opts:["Non, une seule","Oui, en série"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Ne s'allume pas","Une réglette de la série est éteinte","Scintille","Clignote","Grésille"],req:true},
      {id:'starter',l:'Tube rétrofit : starter retiré / shunté ?',type:'select',opts:["Sans objet","Oui","Non"],req:false}
    ]},
  connecte: { ico:'📶', label:'Objet connecté / Domotique', kw:['connecté','connecte','smart','domotique','wifi'],
    q:[
      {id:'app',l:'Application utilisée',type:'text',ph:'ex : Tuya / Smart Life',req:false},
      {id:'wifi',l:'WiFi 2.4 GHz disponible ?',type:'select',opts:["Oui","Non / seulement 5 GHz","Je ne sais pas"],req:true},
      {id:'sympt',l:'Symptôme principal',type:'select',opts:["Appairage impossible","Se déconnecte régulièrement","Ne répond pas aux commandes","Mise à jour bloquée"],req:true}
    ]},
  autre: { ico:'❓', label:'Autre / je ne sais pas', kw:[],
    q:[
      {id:'sympt',l:'Que se passe-t-il ?',type:'select',opts:["Ne s'allume pas","Scintille / clignote","Chauffe","Bruit anormal","Autre"],req:true}
    ]}
};

const MOCK_ORDER = {
  id:'#SIL-102345', date:'28/06/2026', email:'',
  products:[
    {n:'Ruban LED RGB 24V 5m IP20', s:'REF RB-RGB-24V-5M', q:1},
    {n:'Transformateur LED 24V 100W IP67', s:'REF TR-24V-100W', q:1},
    {n:'Télécommande RF + récepteur RGB', s:'REF TC-RF-RGB', q:1}
  ]
};

function flow(){
  const base=['id','motif','product'];
  const per={
    defaut:['famille','diag','photo','solution','contact','recap'],
    casse:['q_casse','photo','solution','contact','recap'],
    erreur:['q_erreur','photo','solution','contact','recap'],
    manquant:['q_manquant','photo','solution','contact','recap'],
    retract:['q_retract','solution','contact','recap'],
    garantie:['q_garantie','contact','recap']
  };
  return base.concat(S.motif?per[S.motif]:['motif']);
}

const app=SGID('app');
const bar=SGID('bar');

function setBar(){const f=flow();const i=Math.min(S.step,f.length-1);bar.style.width=Math.round((i/(f.length-1))*100)+'%';}
let _first=true;
function render(){const f=flow();const key=f[S.step]||'recap';setBar();app.innerHTML=VIEWS[key]?VIEWS[key]():'<p>—</p>';wire(key);wireEnter();
  if(_first){_first=false;return;}
  const h=app.querySelector('h2.q');if(h){h.tabIndex=-1;h.focus({preventScroll:true});}}
function navHTML(next){next=next||'Continuer';return '<div class="nav"><button class="btn ghost" id="back">← Retour</button><button class="btn primary" id="next">'+next+' →</button></div>';}
function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');}
function lc(s){if(!s)return s;if(s.length>1&&s[1]===s[1].toUpperCase()&&s[1]!==s[1].toLowerCase())return s;return s.charAt(0).toLowerCase()+s.slice(1);}
function strip(v){return (v||'').replace(/\s*\(.*?\)\s*/g,' ').trim();}
function withW(v){v=(v||'').trim();return /^\d[\d\s.,]*$/.test(v)?v+' W':v;}
function coupePhrase(v){if(/^non/i.test(v))return "Le ruban n'a été ni coupé ni rallongé.";if(/rallong/i.test(v))return "Le ruban a été rallongé (connecteur ou soudure).";return "Le ruban a été coupé aux marques prévues.";}

/* generic field renderer for diagnostic questions */
function field(q){
  const v=S.answers[q.id]||'';
  const req=q.req?' <span class="req">*</span>':'';
  if(q.type==='select'){
    const opts=['<option value="">— choisir —</option>'].concat(q.opts.map(o=>`<option ${v===o?'selected':''}>${o}</option>`)).join('');
    return `<label class="f" for="f_${q.id}">${q.l}${req}</label><select id="f_${q.id}">${opts}</select>`;
  }
  if(q.type==='textarea'){
    return `<label class="f" for="f_${q.id}">${q.l}${req}</label><textarea id="f_${q.id}" placeholder="${q.ph||''}">${esc(v)}</textarea>`;
  }
  return `<label class="f" for="f_${q.id}">${q.l}${req}</label><input type="text" id="f_${q.id}" placeholder="${q.ph||''}" value="${esc(v)}">`;
}

function detectFamille(){
  const names=(S.selProducts||[]).map(i=>S.order&&S.order.products[i]?S.order.products[i].n:'').join(' ').toLowerCase();
  const src=names||(S.answers.pfree||'').toLowerCase();
  for(const [k,f] of Object.entries(FAMILLES)){
    if(f.kw&&f.kw.length&&f.kw.some(w=>src.includes(w))) return k;
  }
  return null;
}

